import { config } from "../config/config";

const nodeApiBaseUrl = (
  process.env.REACT_APP_NODE_API_URL ||
  config.node_api_url ||
  (window.location.hostname === "localhost" ? "http://localhost:4000" : "")
).replace(/\/+$/, "");

const getAuthHeaders = () => {
  const idTokenKey = Object.keys(localStorage).find((key) => key.includes("idToken")) as string;
  const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : "";
  const hasuraRole = localStorage.getItem("x-hasura-user-role") || "";

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (idToken) {
    headers.Authorization = `Bearer ${idToken}`;
  }
  if (hasuraRole) {
    headers["x-hasura-role"] = hasuraRole;
  }
  return headers;
};

const postRequest = async (path: string, input: Record<string, any> = {}) => {
  const response = await fetch(`${nodeApiBaseUrl}${path}`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ input }),
  });

  const responseData = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(responseData?.message || "Request failed");
  }
  return responseData;
};

export const getRolePageCatalog = () => postRequest("/api/rolePageAccess/pageCatalog");

export const getRolePageAccess = (roleKey: string) =>
  postRequest("/api/rolePageAccess/get", { roleKey });

export const updateRolePageAccess = (roleKey: string, pageKeys: string[]) =>
  postRequest("/api/rolePageAccess/update", { roleKey, pageKeys });

export const getMyRolePageAccess = (roleKey: string) =>
  postRequest("/api/rolePageAccess/myAccess", { roleKey });
